import { forwardRef } from 'react';

import { IconProps } from '.';

export const OpenCircleIcon = forwardRef<SVGSVGElement, IconProps>(({ className, size = 20, ...props }, ref) => {
  return (
    <svg width={size} height={size} viewBox="0 0 20 20" ref={ref} {...props} {...{ className }}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.83323 16.236C7.0666 17.0601 8.51664 17.5 10 17.5C10.9849 17.5 11.9602 17.306 12.8701 16.9291C13.7801 16.5522 14.6069 15.9997 15.3033 15.3033C15.9997 14.6069 16.5522 13.7801 16.9291 12.8701C17.306 11.9602 17.5 10.9849 17.5 10C17.5 8.51664 17.0601 7.0666 16.236 5.83323C15.4119 4.59986 14.2406 3.63856 12.8701 3.07091C11.4997 2.50325 9.99168 2.35472 8.53683 2.64411C7.08197 2.9335 5.7456 3.64781 4.6967 4.6967C3.64781 5.7456 2.9335 7.08197 2.64411 8.53683C2.35472 9.99168 2.50325 11.4997 3.07091 12.8701C3.63856 14.2406 4.59986 15.4119 5.83323 16.236ZM6.66658 5.01119C7.65328 4.3519 8.81332 4 10 4C11.5913 4 13.1174 4.63214 14.2426 5.75736C15.3679 6.88258 16 8.4087 16 10C16 11.1867 15.6481 12.3467 14.9888 13.3334C14.3295 14.3201 13.3925 15.0892 12.2961 15.5433C11.1997 15.9974 9.99335 16.1162 8.82946 15.8847C7.66558 15.6532 6.59648 15.0818 5.75736 14.2426C4.91825 13.4035 4.3468 12.3344 4.11529 11.1705C3.88378 10.0067 4.0026 8.80026 4.45673 7.7039C4.91085 6.60755 5.67989 5.67047 6.66658 5.01119Z"
        fill="currentColor"
      />
    </svg>
  );
});

export default OpenCircleIcon;
